import { underscore } from '@ember/string';

import ActiveModelSerializer from 'active-model-adapter/active-model-serializer';

export default class RegisterOrganizationSerializer extends ActiveModelSerializer {
  modelNameFromPayloadKey() {
    return 'register-organization';
  }

  payloadKeyFromModelName() {
    return 'organization';
  }

  keyForAttribute(attr) {
    return underscore(attr);
  }

  attrs = {
    addressLineOne: 'address_line_1',
    addressLineTwo: 'address_line_2',
  };

  keyForRelationship(key) {
    if (key === 'owner') {
      return 'owner_id';
    }

    if (key === 'stakeholders') {
      return 'stakeholder_ids';
    }

    if (key === 'partnerRegistration') {
      return 'partner_registration_id';
    }

    return key;
  }
}
